import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20editorial%20flat%20lay%20photography%20of%20carefully%20curated%20fashion%20pieces%20including%20textured%20knitwear%20leather%20accessories%20and%20elegant%20footwear%20arranged%20on%20a%20soft%20cream%20linen%20surface%20with%20gentle%20natural%20sunlight%20streaming%20through%20sheer%20curtains%20creating%20a%20dreamy%20atmospheric%20glow%20sophisticated%20minimalist%20composition%20with%20warm%20beige%20sand%20and%20ivory%20tones%20high%20end%20lifestyle%20magazine%20aesthetic&width=1800&height=1200&seq=hero-bg-v2-superbuy-15&orientation=landscape"
          alt="Superbuy Spreadsheet fashion collection flat lay photography"
          title="Superbuy Spreadsheet - Complete Shopping Management System"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-24 md:py-32">
        <div className="max-w-2xl">
          <span className="inline-block px-4 py-1.5 mb-6 border border-white/30 rounded-full text-white/80 text-xs md:text-sm font-medium tracking-wider backdrop-blur-sm">
            Superbuy Spreadsheet Authority
          </span>

          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold leading-tight mb-4">
            <span className="text-white">Superbuy Spreadsheet</span>
            <br />
            <span className="text-white/70 font-medium text-2xl md:text-4xl lg:text-5xl">
              The Complete Shopping Management System For Global Buyers
            </span>
          </h1>

          <p className="text-white/75 text-sm md:text-base max-w-lg mb-8 leading-relaxed">
            Track products, calculate shipping costs, organize orders, and optimize every purchase decision with powerful spreadsheet tools designed for international shoppers.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="group inline-flex items-center gap-3 px-6 py-3.5 bg-black text-white text-sm md:text-base font-semibold rounded-full hover:bg-foreground-800 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <span className="w-7 h-7 rounded-full bg-primary-500 flex items-center justify-center flex-shrink-0">
                <i className="ri-shopping-bag-line text-white text-sm"></i>
              </span>
              <span>Superbuy Sheet</span>
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-white/60 text-sm group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-200"></i>
              </div>
            </a>

            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="group inline-flex items-center gap-3 px-6 py-3.5 bg-white/15 backdrop-blur-sm border border-white/20 text-white text-sm md:text-base font-semibold rounded-full hover:bg-white/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <span>Buy It Now</span>
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-white/70 text-sm group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-200"></i>
              </div>
            </a>
          </div>

          <div className="mt-12 flex items-center gap-6 flex-wrap">
            <Link
              to="/article/superbuy-spreadsheet-complete-guide"
              className="text-white/60 hover:text-white text-xs md:text-sm underline underline-offset-4 decoration-white/20 hover:decoration-white/50 transition-all duration-200"
            >
              Complete Guide &rarr;
            </Link>
            <Link
              to="/article/superbuy-spreadsheet-for-beginners"
              className="text-white/60 hover:text-white text-xs md:text-sm underline underline-offset-4 decoration-white/20 hover:decoration-white/50 transition-all duration-200"
            >
              Beginner's Walkthrough &rarr;
            </Link>
            <Link
              to="/article/superbuy-spreadsheet-shipping-guide"
              className="text-white/60 hover:text-white text-xs md:text-sm underline underline-offset-4 decoration-white/20 hover:decoration-white/50 transition-all duration-200"
            >
              Shipping Tips &rarr;
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-8 h-12 rounded-full border border-white/25 flex items-start justify-center pt-2">
          <div className="w-1 h-2.5 bg-white/40 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}